import { useEffect, useLayoutEffect, useState } from "react";
import IntelLayout from "@components/layout/layout";
import styles from "./TradeLanesProfile.module.scss";
import Panel from "./components/Panel";
import Header from "@containers/TradeLanesProfile/components/Header";
import { getEventName, getUserActivePlan, isProfileAccess } from "@helpers/profileHelper";
import { useLocation, useHistory } from "react-router-dom";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { tradeLaneEvents } from "./utils/enum";
import { generateTrackingObject } from "@core/global/global-country-functions";

const TradeLanesProfile = () => {
  const [showNotification, setShowNotification] = useState(false);
  const { search: searchUrlParams, pathname } = useLocation();
  const history = useHistory();
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");
  const profileName = new URLSearchParams(searchUrlParams).get("profileName");

  useEffect(() => {
    trademoTrackingEvents(getEventName(profileTypeEnum.tradeLanes, tradeLaneEvents.landing), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
  }, [dataSource, pathname]);

  useLayoutEffect(() => {
    const profileAccess = isProfileAccess(profileName);
    if (!profileAccess?.port) {
      history.push("/sample-trade-lane");
    }
  }, [profileName, history]);

  return (
    <IntelLayout
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}
      type={"tradeLanes"}>
      <div className={styles.tradeLanesContainer}>
        <Header />
        <Panel />
      </div>
    </IntelLayout>
  );
};

export default TradeLanesProfile;
